<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 予約状況ダウンロードファイル（作成・編集）の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>予約状況ダウンロードファイル（作成・編集）の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/reservation-download-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、編集した内容は保存されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> メモ
        </div>
        <div class="manual-explain">
          メモを設定します。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 予約施設
        </div>
        <div class="manual-explain">
          ダウンロード対象の予約施設を選択します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 作成期間（開始日時）
        </div>
        <div class="manual-explain">
          集計期間（開始日時）を設定します。<br>
          期間に該当する予約登録日時の予約を出力します。<br>
          全件ダウンロード時は指定不要です。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 作成期間（終了日時）
        </div>
        <div class="manual-explain">
          集計期間（終了日時）を設定します。<br>
          全件ダウンロード時は指定不要です。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 作成ボタン
        </div>
        <div class="manual-explain">
          クリックすることでダウンロードファイルの作成を開始します。<br>
          ※ダウンロードファイルの作成には時間がかかる場合があります<br>
          ※編集時はメモ情報が更新されるのみ
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Reservation Status Download File (Create/Edit)
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Reservation Status Download File (Create/Edit)</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_reservation-download-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.<br>
          Any edited content will not be saved.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Memo
        </div>
        <div class="manual-explain">
          Set a memo.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Reservation Facility
        </div>
        <div class="manual-explain">
          Select the reservation facility to download.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Creation Period (Start Date/Time)
        </div>
        <div class="manual-explain">
          Set the aggregation period (start date/time).<br>
          Outputs reservations with registration date/time within the specified period.<br>
          Not required when downloading all records.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Creation Period (End Date/Time)
        </div>
        <div class="manual-explain">
          Set the aggregation period (end date/time).<br>
          Not required when downloading all records.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Add Button
        </div>
        <div class="manual-explain">
          Click to start creating the download file.<br>
          *Creating the download file may take some time<br>
          *During editing, only memo information is updated
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
